import React from 'react';
import * as S from './BlogsAndLabsDetail.elements';
import {useLoaderData} from "react-router-dom";
import Hero from "../../blocks/Hero/Hero";
import Container from "../../components/Container/Container";
import {Paragraphs} from "../../components/Paragraphs/Paragraphs";
import {Seo} from "../../components/Seo/Seo";
import {useTranslation} from "react-i18next";
import Text from "../../components/Text/Text";
import {Tag} from "../../components/Tag/Tag";

export async function blogsAndLabsDetailLoader({request, params}) {
    const lang = params?.lang;

    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/blogs/${params?.slug}${Boolean(lang) ? `?lang=${lang}` : ''}`, {
        signal: request.signal
    });

    if(!res.ok) {
        throw new Response("Page is not found", { status: 404 });
    }

    const data = await res.json();

    return {data};
}


export const BlogsAndLabsDetail = () => {
    const {data} = useLoaderData();
    const {t} = useTranslation();

    return (
        <>
            <Seo
                title={data?.title}
                description={data?.text}
                slug={`/blog/${data?.slug}`}
                image={data?.imageUrl}
            />

            <Hero
                type="overlap" $small
                superTitle={<Text>{data?.date} <Tag>{t(`blog.type.${data?.type ? data.type : "blog"}`)}</Tag></Text>}
                heading={data?.title}
                text={data?.text}
            />

            <S.HeroOverlap>
                <Container>
                    <S.Outer>
                        <S.Inner src={data?.imageUrl} alt="" />
                    </S.Outer>
                </Container>
            </S.HeroOverlap>

            <Paragraphs data={data?.paragraphs} />
        </>
    );
}